import {Navigate, useRoutes} from 'react-router-dom';

// layouts
import BodyLayout from './layouts/body';
import SimpleLayout from './layouts/simple';

// pages
import Page404 from './pages/Page404';
import HomePage from './pages/HomePage';
import PrivacyPage from "./pages/PrivacyPage";
import FeatureDetailPage from "./pages/FeatureDetailPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PricingPage from "./pages/PricingPage";

// ----------------------------------------------------------------------

export default function Router() {
    return useRoutes([
        {
            path: '',
            element: <>
                <BodyLayout/>
            </>,
            children: [
                {element: <Navigate to="home"/>, index: true},
                {path: 'home', element: <HomePage/>},
                {path: 'features/:featureSlug', element: <FeatureDetailPage/>},
                {path: 'pricing', element: <PricingPage/>},
                {path: 'privacy', element: <PrivacyPage/>},
                {path: 'terms-of-service', element: <TermsOfServicePage/>},
            ],
        },
        {
            element: <SimpleLayout/>,
            children: [
                {element: <Navigate to="overview"/>, index: true},
                {path: '404', element: <Page404/>},
                {path: '*', element: <Navigate to="/404"/>},
            ],
        },
        {
            path: '*',
            element: <Navigate to="/404" replace/>,
        },
    ]);
}
